<template>
  <div ref="charts" style="width: 100%; height: 500px"></div>
</template>

<script>
import echarts from "echarts";
import { onMounted, ref } from "vue";

export default {
  setup() {
    const charts = ref(null);
    let myChart;
    onMounted(() => {
      myChart = echarts.init(charts.value);
    });

    const renderEchart = function (echartsData) {
      let option = {
        tooltip: { 
            show:true,
            trigger: "axis",
            formatter:function(params, ticket, callback){
               return `<div style="padding:2px 5px">
               <div>${params[0].axisValue}</div>
               <div>会员数: ${params[0].data}</div>
               </div>`
            }
        },
        grid: {
          y: 80,
          x: 60,
        },
        xAxis: {
          type: "category",
          data:echartsData.data1,
        },
        yAxis: {
          name:'会员所属地区前五',
          type: "value",
          show:true,
          nameTextStyle:{
              color:'#000',
              fontWeight:800,
              fontSize:14
          }
        },
        series: [
          {
            data: echartsData.data2,
            type: "bar",
             barWidth:60,
             itemStyle:{
                 color:'#183e67'
             }
          },
        ],
      };
      myChart.setOption(option);
    };
    return {
      charts,
      renderEchart
    };
  },
};
</script>
